import { ENVIRONMENT_TYPE } from "../../constant/common";
import { environment } from "../../constant/environment";

export function consoleLog(data: any) {
  // if (environment === ENVIRONMENT_TYPE.PRODUCTION) return;
  console.log(data);
}
